var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBranchWithLeaves(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26 26",
    style: {
      enableBackground: "new 0 0 26 26"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#777"
    },
    d: "M21.184,2.555c0.688,1.202,0.125,1.662-0.436,1.977c-0.561,0.314-1.235,0.425-1.921-0.774 C18.136,2.556,18.11,0,18.11,0S20.494,1.354,21.184,2.555z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#777"
    },
    d: "M24.16,6.004c-0.595,1.251-1.292,1.053-1.87,0.775c-0.581-0.283-1.056-0.773-0.467-2.02 c0.595-1.254,2.674-2.736,2.674-2.736S24.751,4.754,24.16,6.004z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#777"
    },
    d: "M24.564,10.728c-0.897,1.056-1.521,0.685-2.006,0.267c-0.487-0.421-0.82-1.018,0.07-2.071 c0.895-1.06,3.291-1.954,3.291-1.954S25.458,9.672,24.564,10.728z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#777"
    },
    d: "M20.565,9.336c1.229,0.716,0.978,1.396,0.65,1.949c-0.329,0.554-0.863,0.984-2.09,0.271 c-1.232-0.715-2.59-2.946-2.59-2.946S19.333,8.622,20.565,9.336z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#777"
    },
    d: "M22.944,15.583c-1.202,0.688-1.662,0.128-1.979-0.431c-0.315-0.561-0.426-1.237,0.771-1.925 c1.201-0.691,3.759-0.721,3.759-0.721S24.145,14.893,22.944,15.583z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#777"
    },
    d: "M19.835,13.057c0.88,1.121,0.393,1.659-0.114,2.052c-0.509,0.396-1.169,0.596-2.045-0.521 c-0.878-1.121-1.312-3.695-1.312-3.695S18.956,11.94,19.835,13.057z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#777"
    },
    d: "M20.428,19.678c-1.366,0.24-1.607-0.443-1.716-1.076c-0.108-0.636,0.015-1.307,1.372-1.55 c1.367-0.243,3.783,0.597,3.783,0.597S21.786,19.434,20.428,19.678z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#777"
    },
    d: "M18.198,16.285c0.601,1.292,0,1.704-0.584,1.971c-0.587,0.266-1.271,0.311-1.866-0.975 c-0.601-1.293-0.432-3.9-0.432-3.9S17.602,14.995,18.198,16.285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#777"
    },
    d: "M15.474,18.787c0.245,1.4-0.438,1.645-1.07,1.753c-0.636,0.103-1.312-0.028-1.555-1.424 c-0.245-1.404,0.587-3.88,0.587-3.88S15.228,17.385,15.474,18.787z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#777"
    },
    d: "M16.792,22.827c-1.409-0.209-1.424-0.937-1.327-1.57c0.104-0.638,0.44-1.234,1.843-1.024 c1.409,0.211,3.496,1.783,3.496,1.783S18.197,23.037,16.792,22.827z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#777"
    },
    d: "M12.398,21.047c0.102,1.42-0.603,1.594-1.244,1.637c-0.643,0.037-1.3-0.164-1.403-1.576 c-0.098-1.422,0.983-3.799,0.983-3.799S12.299,19.63,12.398,21.047z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#777"
    },
    d: "M12.762,25.197c-1.344-0.477-1.221-1.192-1.001-1.796c0.221-0.606,0.668-1.127,2.005-0.654 c1.342,0.477,3.088,2.419,3.088,2.419S14.1,25.67,12.762,25.197z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#777"
    },
    d: "M20.163,5.464c1.366,0.37,1.298,1.096,1.126,1.712c-0.174,0.621-0.579,1.175-1.939,0.806 c-1.371-0.37-3.243-2.17-3.243-2.17S18.798,5.095,20.163,5.464z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#777"
    },
    d: "M10.638,23.44c0,0-6.453,2.538-10.479,1.634C-0.157,25.45,0.605,26,0.605,26 S6.465,26.091,10.638,23.44z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBranchWithLeaves);
export default __webpack_public_path__ + "static/media/branch-with-leaves.44137374c5be01f0f66b757d93ff4279.svg";
export { ForwardRef as ReactComponent };